import { useLaunchParams } from '@tma.js/sdk-react';

export const useProfilePicture = () => {
    const lp = useLaunchParams(true);
    return lp.tgWebAppData?.user?.photoUrl;
};
